export default {
  nav: {
    home: 'ホーム',
    features: '機能',
    pricing: '料金',
    faq: 'FAQ',
    translate: '漫画翻訳',
    startBtn: '翻訳開始',
    vip: 'VIPチャンネル',
    login: 'ログイン',
    logout: 'ログアウト',
    lang: '日本語',
  },
  landing: {
    title: 'KokeManga スーパー漫画翻訳ツール',
    subtitle: 'AI搭載 · バッチ処理 · オリジナルレンダリング',
    desc: '無料オンライン漫画翻訳ツール、JPG、PNG、WEBP形式対応',
    hero: {
      badge: 'AI搭載の漫画翻訳',
      title: 'スマート漫画翻訳',
      gradientText: 'ワンクリック完了',
      desc: 'バッチアップロード · AI認識 · オリジナルレンダリング · 多言語翻訳',
      startBtn: '翻訳開始',
      learnMore: '詳しく見る',
      statsTranslated: '累計翻訳',
      statsFree: '無料枠',
      statsFreeNum: '20枚/日',
      statsAccuracy: '認識精度',
    },
    comparison: {
      afterLabel: '翻訳後',
      beforeLabel: '原画',
    },
    advantage: {
      tag: '選ばれる理由',
      title: '強力な翻訳能力',
      desc: '漫画翻訳に特化したAIツール、翻訳をシンプルで効率的に',
      items: [
        {
          title: 'AIスマート翻訳',
          desc: '各画像に<span class="highlight">大モデル翻訳を採用、従来の機械翻訳を排除</span>、テキストをインテリジェントに認識し元のレイアウトを維持',
        },
        {
          title: 'オリジナルレンダリング',
          desc: '漫画スタイルと背景をインテリジェントに認識、翻訳テキストのぼかし・修復を行い、元のスタイルに完璧に融合',
        },
        {
          title: 'バッチ処理',
          desc: '複数の漫画画像を一括アップロード、ワンクリックで章全体を翻訳、作業効率を大幅に向上',
        },
        {
          title: '多言語対応',
          desc: '中国語、繁体字中国語、英語翻訳対応、今後さらに多くの言語を追加予定',
        },
        {
          title: 'プライバシー保護',
          desc: '全データ暗号化、翻訳完了後<span class="highlight">24時間以内に自動削除</span>、アップロード・翻訳データを保持しません',
        },
        {
          title: '多形式エクスポート',
          desc: 'JPG、PNG、WEBPなど多形式のダウンロード対応、異なるプラットフォームのニーズに対応',
        },
      ],
    },
    pricing: {
      tag: 'コンピュートパワー',
      title: '柔軟な料金体系',
      desc: 'コンピュートパワーを取得してVIPチャンネルをアンロック、高速翻訳、大画像翻訳などVIP機能をお楽しみください。コンピュートパワーは永久に有効です',
      unit: 'コンピュートパワー',
      note: '購入したコンピュートパワーは永久に有効で期限切れになりません。VIPチャンネルは使用ごとにコンピュートパワーを消費し、消費量は画像解像度によって計算されます。',
      packages: [
        { amount: '300 コンピュートパワー', price: '¥6', desc: '約240-300枚の漫画が翻訳可能' },
        { amount: '600 コンピュートパワー', price: '¥12', desc: '約480-600枚の漫画が翻訳可能' },
        { amount: '3000+1000 コンピュートパワー', price: '¥60', desc: '約3200-4000枚の漫画が翻訳可能', badge: '+33%' },
        { amount: '6000+3000 コンピュートパワー', price: '¥120', desc: '約7200-9000枚の漫画が翻訳可能', badge: '+50%' },
      ],
    },
    channelCompare: {
      title: 'チャンネル比較',
      free: {
        title: 'パブリックキュー（無料）',
        desc: '急いでいないユーザー向け、キューで翻訳を待機',
        items: ['ログイン不要', '完全無料、コンピュートパワー消費なし', 'キュー優先度低', '毎日の翻訳数制限', '大画像非対応（最大2000×2000）', 'オンライン編集非対応'],
      },
      vip: {
        title: 'VIPチャンネル（コンピュートパワー消費）',
        desc: '高速翻訳、大画像対応、使用ごとにコンピュートパワー消費',
        items: ['ログイン必要（無料機能すべての権益）', 'より多くの翻訳設定', '高速キュー、優先翻訳', '回数無制限、使用ごとにコンピュートパワー消費', '大画像対応（最大2000×20000）', 'オンライン編集対応'],
      },
    },
    faq: {
      tag: 'よくある質問',
      title: 'FAQ',
      desc: 'その他ご質問がございましたら、お問い合わせください',
      items: [
        { q: 'パブリックキュー（無料）で何枚翻訳できますか？', a: 'ログインなしで毎日20枚の無料翻訳をサポートしています。VIPキューと同じ品質です。' },
        { q: 'なぜ翻訳に時間がかかるのですか？', a: '品質を確保するため大モデル翻訳を採用しており、平均して各画像の処理に7-8秒かかります。' },
        {
          q: 'なぜ一部の画像はより多くのコンピュートパワーが必要ですか？',
          a: '通常の画像は1コンピュートパワーです。長画像や超高解像度の画像のみより多くのコンピュートパワーを消費します。2コンピュートパワーは4K以上の解像度に対応します。',
        },
        { q: '翻訳に問題があった場合、解決してもらえますか？', a: '翻訳に関するあらゆる問題に対応いたします。失敗した場合、失敗分のコンピュートパワーを返還し、ユーザーのすべての合法权益を保障します。' },
        {
          q: '従来の機械翻訳と大モデル翻訳の違いは？',
          a: '従来の機械翻訳は固定ルールと辞書に依存し、翻訳が硬く、文脈が途切れ、意味エラーが頻発します。大モデル翻訳は深層学習に基づき、文脈を理解し、より自然で流暢な翻訳を実現します。漫画の口語表現、擬音語、文化的ネタの処理に特に優れています。',
        },
      ],
    },
    cta: {
      title: '準備はできましたか？',
      desc: 'Koke Mangaを始めて、スマート漫画翻訳を体験しましょう',
      btn: '今すぐ翻訳を開始',
    },
    footer: {
      features: '機能',
      pricing: '料金',
      faq: 'FAQ',
      login: 'ログイン',
    },
    startBtn: '翻訳開始',
  },
  translate: {
    pageTitle: 'スマート漫画翻訳ツール',
    pageDesc: 'ワンクリックアップロード · 自動翻訳 · パブリックキュー · オリジナルレンダリング',
    guideArrow: 'クリックしてプレビュー',
    uploadTitle: '漫画をバッチアップロード',
    previewTitle: '漫画プレビュー',
    historyTitle: '翻訳履歴',
    batchDownload: 'バッチダウンロード',
    downloading: 'ダウンロード中...',
    clearList: 'リストクリア',
    previewDialog: 'プレビュー',
    confirm: 'OK',
    cancel: 'キャンセル',
    systemPrompt: 'システム通知',
    reLogin: '再ログイン',
    httpError: 'HTTPエラー',
    deleteConfirm: 'このファイルを削除してもよろしいですか？',
    deleteTitle: 'ヒント',
    deleteSuccess: '削除成功、バックエンドキャッシュクリア済み',
    deleteFailed: '削除失敗',
    clearConfirm: 'すべてのファイル記録とバックエンドキャッシュをクリアしますか？この操作は元に戻せません。',
    clearTitle: '警告',
    clearSuccess: 'すべての記録をクリアし、バックエンドキャッシュをクリアしました',
    clearFailed: 'クリア失敗',
    selectFilesFirst: 'ダウンロードするファイルを先に選択してください',
    invalidFiles: '選択されたファイルのうち{count}個に有効なIDがなく、ダウンロードできません',
    incompleteFiles: '選択されたファイルのうち{count}個がまだ翻訳完了しておらず、ダウンロードできません',
    downloadingWait: 'ダウンロード中、お待ちください...',
    batchDownloadStart: '{count}個のファイルのバッチダウンロードを開始...',
    batchDownloadSuccess: 'バッチダウンロード成功',
    batchDownloadFailed: 'バッチダウンロード失敗',
    downloadSuccess: 'ダウンロード成功',
    downloadFailed: 'ダウンロード失敗',
    fileNotFound: 'ファイルが存在しないか、削除されています',
    serverError: 'サーバー内部エラー',
    networkError: 'ネットワーク異常、ネットワーク接続を確認して再試行してください',
    noFileFound: '対応するファイルが見つかりません',
    fileIdMissing: 'ファイルIDが存在しません',
    fileNotComplete: '翻訳がまだ完了していません、お待ちください',
    paramError: 'リクエストパラメータエラー、選択したファイルを確認してください',
    privacy: 'プライバシーポリシー',
    agreement: '利用規約',
    about: '私たちについて',
    batchDownloadFilename: '漫画翻訳バッチダウンロード',
    uploadFirst: '先に画像をアップロードしてください',
    uploadFailed: 'アップロード失敗',
    uploadNetworkError: 'ネットワーク異常',
    uploadResult: 'アップロード結果',
    uploadSuccess: 'アップロード完了！{count}枚成功',
    joinQueue: '翻訳キューに参加',
    imageCount: '{current}/{total}枚({size})',
    imagePreview: '漫画プレビュー',
  },
  manga: {
    navbar: {
      home: 'ホーム',
      freeQueue: '無料キュー',
      vipQueue: 'VIPキュー',
      loggedIn: 'ログイン済み',
      currentTasks: '現在のタスク',
      currentCredits: '現在のコンピュートパワー',
      getCredits: 'コンピュートパワー取得',
      myOrders: '注文履歴',
      myTranslations: '翻訳履歴',
      profile: 'プロフィール',
      feedback: 'フィードバック',
      logout: 'ログアウト',
      user: 'ユーザー',
      taskCount: '{count}個',
    },
    footer: {
      privacy: 'プライバシーポリシー',
      agreement: '利用規約',
      about: '私たちについて',
    },
    queueCard: {
      publicQueue: 'パブリック翻訳キュー：',
      people: '名',
      realtime: 'リアルタイム更新 · 全員共用',
      speedQueue: 'Speed加速キュー：',
      speedDesc: '毎日最初の100枚 · 優先翻訳',
      vipQueue: 'VIP専用キュー：',
      vipDesc: '高速翻訳 · VIP限定',
    },
    upload: {
      dragHint: 'クリックまたはドラッグで画像をアップロード',
      translating: '翻訳中、お待ちください...',
      tip: '最大{max}枚、各10MB以下、合計50MB以下',
      processing: '処理中...',
      onlyImages: '画像ファイルのみアップロード可能です！',
      sizeLimit: '画像サイズは10MBを超えることはできません！',
      totalSizeLimit: 'すべての画像の合計サイズは50MBを超えることはできません',
      maxFiles: '最大{max}枚の画像のみ選択可能です',
      fileExists: 'ファイル{name}は既に存在します、スキップします',
      added: '{name}を追加しました、現在合計{count}枚',
      removed: '{name}を削除しました、残り{count}枚',
      waitTranslate: '翻訳中です、翻訳完了後に追加してください',
    },
    fileList: {
      empty: '翻訳記録なし',
      selectAll: 'すべて選択 ({selected}/{max})',
      timeJustNow: 'たった今',
      timeMinutesAgo: '{count}分前',
      timeHoursAgo: '{count}時間前',
      timeDaysAgo: '{count}日前',
    },
    preview: {
      placeholder: 'アップロード後に漫画をプレビューできます',
      clearAll: 'すべてクリア',
      uploading: 'アップロード中 {progress}%',
      joinQueue: '翻訳キューに参加',
    },
    login: {
      welcomeBack: 'おかえりなさい',
      createAccount: 'アカウント作成',
      loginSubtitle: 'ログインしてVIP専用翻訳チャンネルを利用',
      registerSubtitle: '登録してVIP翻訳サービスを体験',
      email: 'メールアドレス',
      password: 'パスワード',
      confirmPassword: 'パスワード確認',
      loginBtn: 'ログイン',
      registerBtn: '登録',
      noAccount: 'アカウントをお持ちでない方はこちら',
      hasAccount: 'アカウントをお持ちの方はこちら',
      forgotPassword: 'パスワードを忘れた方',
      loginAgreement: 'ログインすることで以下に同意したものとみなされます',
      registerAgreement: '登録することで以下に同意したものとみなされます',
      and: 'と',
      privacyPolicy: 'プライバシーポリシー',
      channelCompare: 'チャンネル比較',
      channelDesc: '無料チャンネルとVIPチャンネルの違いを確認、VIPチャンネルはコンピュートパワーを消費します',
      freeQueue: 'パブリックキュー（無料）',
      freeQueueDesc: '急いでいないユーザー向け、キューで翻訳を待機',
      freeItems: ['ログイン不要', '完全無料、コンピュートパワー消費なし', 'キュー優先度低', '毎日の翻訳数制限', '大画像非対応（最大2000×2000）', 'オンライン編集非対応'],
      vipQueue: 'VIPチャンネル（コンピュートパワー消費）',
      vipQueueDesc: '高速翻訳、大画像対応、使用ごとにコンピュートパワー消費',
      vipItems: ['ログイン必要（無料機能すべての権益）', 'より多くの翻訳設定', '高速キュー、優先翻訳', '回数無制限、使用ごとにコンピュートパワー消費', '大画像対応（最大2000×20000）', 'オンライン編集対応'],
      usageTipTitle: '使用のヒント',
      usageTipDesc: '無料ユーザーはパブリックキューで無料翻訳が利用できます。高速翻訳や大画像翻訳が必要な場合はVIPチャンネルをご利用ください。購入したコンピュートパワーは期限切れになりません。',
      emailRequired: 'メールアドレスを入力してください',
      emailInvalid: '有効なメールアドレスを入力してください',
      passwordRequired: 'パスワードを入力してください',
      passwordMin: 'パスワードは6文字以上で入力してください',
      confirmRequired: 'パスワードを確認してください',
      confirmMismatch: '入力されたパスワードが一致しません',
      agreementTitle: '利用規約',
      privacyTitle: 'プライバシーポリシー',
      loginSuccess: 'ログイン成功',
      registerSuccess: '登録成功、ログインしてください',
      loginFailed: 'ログイン失敗、メールアドレスとパスワードを確認してください',
      registerFailed: '登録失敗、後でもう一度お試しください',
    },
    vip: {
      pageTitle: 'VIP専用翻訳チャンネル',
      pageDesc: 'VIP限定 · 優先処理 · 専用キュー · 無制限',
      uploadTitle: 'VIP専用アップロード',
      previewTitle: 'VIP専用プレビュー',
      historyTitle: 'VIP翻訳履歴',
      maxImages: '最大50枚',
      eachLimit: '各10MB以下',
      totalLimit: '合計50MB以下',
      batchMax: 'バッチダウンロード最大50枚',
      clearHistory: 'クリア中...',
      clear: 'クリア',
      searchPlaceholder: 'ファイル名を入力',
      statusLabel: '翻訳ステータス',
      waiting: '翻訳待ち',
      translating: '翻訳中',
      failed: '翻訳失敗',
      completed: '完了',
      query: '検索',
      reset: 'リセット',
      fileName: '漫画名',
      translateStatus: '翻訳ステータス',
      currentQueue: '現在のキュー',
      creditsCost: '消費コンピュートパワー',
      targetLanguage: '対象言語',
      action: '操作',
      noRecords: '翻訳記録なし',
      refresh: '更新',
      configTitle: '翻訳設定',
      configLangLabel: '対象翻訳言語',
      configLangPlaceholder: '翻訳言語を選択',
      configLayoutLabel: 'レイアウトモード',
      configLayoutPlaceholder: 'レイアウトモードを選択',
      configOnlineEditLabel: 'オンライン編集(1クレジット)',
      configOnlineEditOn: 'オン',
      onlineEdit: 'オンライン編集',
      editDataMissing: 'この記録には編集データがありません',
      configOnlineEditOff: 'オフ',
      configConfirm: '確定',
      statusWaiting: '翻訳待ち',
      statusTranslating: '翻訳中',
      statusFailed: '翻訳失敗',
      statusCompleted: '完了',
      statusExpired: '期限切れ',
      statusUnknown: '不明',
      defaultLang: '簡体字中国語',
      fileNotFound: 'ファイルが存在しないか、削除されています',
      serverError: 'サーバー内部エラー、ダウンロード失敗',
      networkError: 'ネットワーク異常、ネットワーク接続を確認して再試行してください',
      noFileFound: '対応するファイルが見つかりません',
      fileNotComplete: '翻訳がまだ完了していません、お待ちください',
      fileIdMissing: 'ファイルIDが存在しません、プレビューできません',
      selectFilesFirst: 'ダウンロードするファイルを先に選択してください',
      downloadingWait: 'ダウンロード中、お待ちください...',
      incompleteFiles: '選択されたファイルのうち{count}個がまだ翻訳完了しておらず、ダウンロードできません',
      batchDownloadStart: 'VIPバッチダウンロードを開始、{count}個のファイル...',
      paramError: 'リクエストパラメータエラー、選択したファイルを確認してください',
      deleteConfirm: 'この記録を削除してもよろしいですか？',
      deleteTitle: 'ヒント',
      deleteSuccess: '削除成功',
      deleteFailed: '削除失敗',
      clearConfirm: '完了および失敗したすべての翻訳記録をクリアしてもよろしいですか？この操作は元に戻せません。',
      clearSuccess: 'クリア成功',
      clearFailed: 'クリア失敗',
    },
    getPower: {
      title: '漫画翻訳コンピュートパワー取得',
      subtitle: 'コンピュートパワーを取得してVIPチャンネルをアンロック、高速翻訳、大画像翻訳などVIP機能をお楽しみください。VIP機能は回数無制限、使用ごとにコンピュートパワーを消費',
      contactAdmin: '管理者に連絡',
      currentBalance: '現在の残高',
      creditsUnit: 'コンピュートパワー',
      packageTitle: 'コンピュートパワー購入パッケージ',
      packageDesc: '以下のパッケージからコンピュートパワーを購入、VIPチャンネルに使用可能、永久に有効',
      noPackage: '購入可能なパッケージなし',
      payMethod: '支払い方法',
      alipay: 'Alipay',
      wechatPay: 'WeChat Pay',
      selectPackage: 'パッケージを選択してください',
      buyButton: '今すぐ購入',
      privacyTitle: 'プライバシー保護',
      privacyDesc: 'ユーザーのプライバシーを保護するため、翻訳された画像は保存しません。すべての翻訳データは完了後24時間以内に自動的にクリアされます。翻訳完了後、速やかにダウンロードしてください。',
      channelCompare: 'チャンネル比較',
      channelDesc: '無料チャンネルとVIPチャンネルの違いを確認、VIPチャンネルはコンピュートパワーを消費します',
      usageTipTitle: '使用のヒント',
      usageTipDesc: '無料ユーザーはパブリックキューで無料翻訳が利用できます。高速翻訳や大画像翻訳が必要な場合はVIPチャンネルをご利用ください。購入したコンピュートパワーは期限切れになりません。',
      calcTitle: 'コンピュートパワー計算式',
      calcDesc: '画像ごとの消費 = ⌈幅 × 高さ ÷ 4,000,000⌉（2000×2000ピクセルで1コンピュートパワー）。端数は切り上げて加算され、1枚につき最低1コンピュートパワー。',
      payPending: '支払い待ち',
      paySuccess: '支払い成功！',
      payFailed: '支払い失敗',
      createOrderFailed: '支払い注文の作成に失敗',
      pleaseSelectPackage: '先にパッケージを選択してください',
      qrcodeTitle: 'QRコードで支払い',
      qrcodeDesc: '{method}でスキャンして支払い',
      payConfirming: '支払い確認中...',
      payTimeout: '支払いタイムアウト、再試行してください',
    },
    order: {
      loading: '読み込み中...',
      typeGift: 'ギフト',
      typeAlipay: 'Alipay',
      typeWechat: 'WeChat',
      typeBilibili: 'Bilibili',
      typePaypal: 'PayPal',
      statePending: '支払い待ち',
      stateSuccess: '支払い成功',
      stateFailed: '支払い失敗',
      stateConfirming: '確認中',
      stateClosed: '閉じる',
      unknown: '不明',
    },
    userMessage: {
      pending: '処理待ち',
      replied: '返信済み',
      placeholder: 'メッセージを入力してください...',
      submitting: '送信中...',
      submit: '送信',
      messageContent: 'メッセージ内容',
      suggestionContent: '提案内容',
      message: 'メッセージ',
      suggestion: '提案',
    },
    userProfile: {
      nicknamePlaceholder: 'ニックネームを入力',
      phoneBound: 'バインド済み {phone}',
      phoneUnbound: '電話未バインド',
      emailBound: 'バインド済み {email}',
      emailUnbound: 'メール未バインド',
      wechatBound: 'WeChat認証済み',
      wechatUnbound: 'WeChat未バインド',
      change: '変更',
      bind: 'バインド',
      unbind: 'アンバインド',
      selectImageError: '画像ファイルを選択してください',
      imageSizeError: '画像サイズは5MBを超えることはできません',
      avatarSuccess: 'アバターアップロード成功',
      avatarFailed: 'アップロード失敗',
      avatarRetry: 'アップロード失敗、再試行してください',
      saveSuccess: 'プロフィール保存成功',
      saveFailed: '保存失敗',
      saveRetry: '保存失敗、再試行してください',
    },
    resetPassword: {
      title: 'パスワードリセット',
      step1: 'メール確認',
      step2: 'コード入力',
      step3: '新しいパスワード設定',
      emailPlaceholder: '登録メールアドレスを入力',
      sendCode: 'コード送信',
      codePlaceholder: '確認コードを入力',
      newPassword: '新しいパスワード',
      confirmPassword: 'パスワード確認',
      resetBtn: 'パスワードリセット',
      backToLogin: 'ログインに戻る',
      stepDesc1: '登録時に使用したメールアドレスを入力してください',
      stepDesc2: '受信した6桁の確認コードを入力してください',
      stepDesc3: '新しいパスワードを設定してください',
      codeSentTo: '確認コード送信先:',
      resendAfter: '{countdown}秒後に再送信可能',
      resendCode: '確認コード再送信',
      verifyBtn: '確認',
      codeRequired: '確認コードを入力してください',
      codeLen: '確認コードは6桁の数字です',
      emailRequired: 'メールアドレスを入力してください',
      emailInvalid: '有効なメールアドレスを入力してください',
      passwordRequired: 'パスワードを入力してください',
      passwordMin: 'パスワードは6文字以上で入力してください',
      confirmRequired: 'パスワードを確認してください',
      confirmMismatch: '入力されたパスワードが一致しません',
      codeSentSuccess: '確認コードを送信しました、メールを確認してください',
      verifySuccess: '確認成功、新しいパスワードを設定してください',
      resetSuccess: 'パスワード変更成功、再度ログインしてください',
    },
    seo: {
      landing: {
        title: 'KokeManga スーパー漫画翻訳ツール - AI搭載 · バッチ処理 · オリジナルレンダリング',
        description: 'KokeMangaは無料オンライン漫画翻訳ツール、JPG、PNG、WEBP形式対応、AIスマート翻訳とバッチ処理。',
      },
      translate: {
        title: 'KokeManga 漫画翻訳 - オンライン翻訳ツール',
        description: 'オンライン漫画翻訳ツール、バッチアップロード、自動翻訳、オリジナルレンダリング対応',
      },
      vip: {
        title: 'KokeManga VIP専用翻訳チャンネル',
        description: 'VIP限定漫画翻訳チャンネル、優先処理、専用キュー、回数無制限',
      },
      faq: {
        title: "KokeManga よくある質問 - 無料オンライン漫画翻訳ツール",
        description: "KokeManga漫画翻訳のFAQ：無料枠、翻訳速度、クレジット、大画像、プライバシー、AIと機械翻訳の違い。",
      },
      guide: {
        title: "漫画翻訳完全ガイド - オンラインAI漫画ローカライズ · KokeManga",
        description: "アップロードから書き出しまでの漫画翻訳ガイド。バッチ処理、オリジナルレンダリング、画質設定、多言語翻訳のコツ。",
      },
      privacy: {
        title: "KokeManga プライバシーポリシー - 漫画翻訳データ保護",
        description: "KokeMangaがアップロードされた漫画画像をどのように扱うか。ローカル処理優先、24時間自動削除、学習利用なし。",
      },
      agreement: {
        title: "KokeManga 利用規約 - オンライン漫画翻訳サービス",
        description: "オンライン漫画翻訳ツールKokeMangaの利用規約。利用ルール、免責事項、責任制限について。",
      },
      login: {
        title: "KokeManga ログイン",
        description: "KokeMangaにログインしてVIP翻訳チャンネルと翻訳履歴を利用。",
      },
      resetPassword: {
        title: "パスワードリセット - KokeManga",
        description: "KokeMangaアカウントのパスワードをリセットします。",
      },
    },
    privacy: {
      intro: 'オンライン漫画翻訳ツールへようこそ。プライバシーとデータセキュリティを非常に重視しています。このプライバシーポリシーでは、お客様の情報、特にアップロードされた漫画画像の収集、使用、保存、処理方法を明確に説明します。',
      s1Title: '1. 情報の収集',
      s1Content: '本ツールの使用時にお客様が actively 選択しアップロードした漫画画像ファイルのみを収集・アクセスします。これ以外に、個人を特定できる情報（氏名、メールアドレス、IPアドレス、デバイス情報など）を積極的に収集、保存、要求することはありません。',
      s2Title: '2. 情報の使用方法',
      s2Content: 'アップロードされた漫画画像は、お客様が要求した即時翻訳サービスの提供のみに使用されます。コアの画像処理、テキスト認識、翻訳計算は、お客様のローカルブラウザまたはデバイスで実行されます。以下を約束します：',
      s2Item1: 'ローカル処理：アップロードされた画像ファイルは、当社のサーバーまたはサードパーティのサーバーに自動的、積極的、または定期的に送信されて処理されることはありません。',
      s2Item2: '目的限定：画像コンテンツは翻訳結果の生成にのみ使用され、機械学習モデルのトレーニング、コンテンツ分析、マーケティング、再配布などの他の目的には使用されません。',
      s3Title: '3. 情報の保存と保持',
      s3Content: '一時ファイルのセキュリティの重要性を理解しています。データ保存の原則は以下の通りです：',
      s3Item1: '自動削除：アップロードされたすべてのオリジナル画像ファイルと生成された翻訳結果は、処理完了後24時間以内にシステムから永久かつ不可逆的に削除されます。',
      s3Item2: '長期アーカイブなし：アップロードされたコンテンツに関連する長期データベース、アーカイブ、バックアップを作成または保持することはありません。',
      s4Title: '4. お客様の権利',
      s4Content: 'データ提供者として、お客様には以下の権利があります：',
      s4Item1: '制御権：アップロードされたコンテンツを完全に制御できます。使用後いつでもブラウザタブを閉じることができます。',
      s4Item2: '知る権利：このポリシーを通じて、ファイルの処理方法を理解する権利があります。',
      s5Title: '5. サードパーティサービス',
      s5Content: '現在のサービスには、サードパーティの分析、広告、追跡ツールの組み込みは含まれていません。機能改善のために信頼できるサードパーティサービスが導入される場合、このポリシーで明確に説明し、同等の厳格なプライバシー基準を満たすことを確認します。',
      s6Title: '6. プライバシーポリシーの変更',
      s6Content: 'このプライバシーポリシーは随時更新される場合があります。重大な変更がある場合は、ツールインターフェースに目立つ通知を掲載します。サービスの継続的な使用は、更新されたポリシーの受諾を構成します。',
      s7Title: '7. お問い合わせ',
      s7Content: "このプライバシーポリシーまたはデータ処理慣行についてご質問、ご意見、ご懸念がございましたら、以下までお問い合わせください：Koke7359{'@'}163.com",
      s8Title: '8. 適用法',
      s8Content: 'このプライバシーポリシーの締結、執行、解釈は中華人民共和国法律に準拠します',
    },
    agreement: {
      updateDate: '最終更新日：2026年4月2日',
      intro: 'オンライン漫画翻訳ツール（以下「本ツール」または「本服務」）へようこそ。使用前にこの利用規約（以下「本規約」）の全文をよくお読みください。本規約のいずれかの条項に同意されない場合は、直ちに本ツールの使用を中止してください。アップロード、アクセス、または使用することで、本規約およびプライバシーポリシーを読み、理解し、完全に受諾したものとみなされます。',
      s1Title: '1. サービスの説明',
      s1Content: '本ツールは無料のオンライン技術翻訳サービスを提供します：テキストを含む漫画画像をアップロードすると、技術的手段（画像認識、機械翻訳など）を通じて翻訳結果を生成します。翻訳結果はアルゴリズムによって自動生成され、理解の補助のみを目的としており、その正確性、完全性、適用性について明示または黙示の保証は行われないことを理解し同意します。',
      s2Title: '2. ユーザー行動規範',
      s2Content: 'お客様は、すべての適用法令を遵守し、本サービスの使用から生じるすべての責任を独立して負うことを約束します。本サービスの使用時に以下の行為を行ってはなりません：',
      s2Subtitle1: '以下の内容を含む、または関連する漫画画像のアップロード、送信、共有、保存：',
      s2Item1: '権利侵害コンテンツ：他人の知的財産権（著作権、商標権など）、肖像権、プライバシー権、その他の合法的権利利益を侵害するコンテンツ。',
      s2Item2: '違法・非準拠コンテンツ：法律、規制、規則、条例に違反するコンテンツ、または違法、詐欺、中傷、ハラスメント、脅迫的な情報を含むコンテンツ。',
      s2Item3: '有害・不適切コンテンツ：ポルノ、わいせつ、暴力、流血、ヘイトスピーチを含むコンテンツ、または人種、性別、宗教、障害、性的指向に基づく差別を助長するコンテンツ。',
      s2Item4: '機密コンテンツ：国家機密、国家安全保障、公共安全、政治的機密性、未成年者に不適切なコンテンツを含むコンテンツ。',
      s2Subtitle2: 'その他の禁止行為：',
      s2Item5: '本ツールを商業目的、違法目的、またはサービスの正常な運営を妨害または破壊する行為（システムへの侵入試行、マルウェアのアップロードなど）に使用すること。',
      s2Item6: '個人または団体になりすますこと、または個人または団体との関連について虚偽の陳述をすること。',
      s3Title: '3. ユーザーアップロードコンテンツの責任',
      s3Content1: 'お客様は、アップロードしたすべての漫画画像コンテンツ（以下「ユーザーコンテンツ」）について完全な法的責任を負うものとします。アップロードに必要なすべての法的権利を保有しているか、十分な授權を取得していることを保証し、コンテンツの使用が法律に違反せず、第三者の権利を侵害しないことを保証します。',
      s3Content2: 'アップロードされたコンテンツが本規約に違反した場合、関連する法的責任はお客様が負うものとします。当社または第三者に損失が生じた場合、お客様は全額賠償の責任を負います。',
      s4Title: '4. 知的財産権',
      s4Content1: 'お客様の権利：アップロードしたオリジナル漫画画像に対するすべての知的財産権および関連権利を保持します。アップロード行為自体が、権利の移転を意味するものではありません。',
      s4Content2: '当社の権利：本ツールおよびサービス（ソフトウェア、インターフェース、ロゴ、技術などを含むがこれらに限定されない）に含まれるすべての知的財産権および関連権利は、当社および/またはライセンサーに帰属します。当社の明示的な書面許可なく、いかなる形式でも複製、改変、リバースエンジニアリング、商業的使用を行うことはできません。',
      s5Title: '5. サービスの変更、中断、終了',
      s5Content1: '当社は、お客様に事前に通知することなく、いつでも本サービス（またはその一部）を変更、一時停止、または中断する権利を留保し、お客様または第三者に対する責任を負いません。',
      s5Content2: 'お客様が本規約のいずれかの条項に違反した合理的な根拠がある場合、当社は一方的に直ちにサービスの提供を一時停止または終了し、関連するユーザーコンテンツを削除する権利を有し、責任を負いません。',
      s6Title: '6. 免責事項',
      s6Content: '適用法で許可される最大限の範囲で、本サービスは「現状有姿」および「利用可能」の状態で提供され、いかなる形式の明示または黙示の保証も提供されません。お客様は以下を理解し同意します：',
      s6Item1: 'サービスが中断されない、タイムリー、安全、エラーがないことを保証しません。',
      s6Item2: '翻訳結果の正確性、信頼性、適用性を保証しません。翻訳結果は参考のみであり、専門的な翻訳アドバイスを構成するものではありません。その価値を判断し、使用結果に責任を負うものとします。',
      s6Item3: 'アップロードされたコンテンツから生じる直接的、間接的、偶的、偶発的、懲罰的、または結果的な損失（データ損失、利益損失、のれん損失などを含むがこれらに限定されない）について、損害が発生する可能性について通知されていたかどうかにかかわらず、責任を負いません。',
      s7Title: '7. データ保持',
      s7Content: 'プライバシーポリシーに従い、アップロードされた画像と生成された翻訳結果を一時的に処理することを確認し同意します。すべてのデータは処理完了後24時間以内に自動的にクリアされます。保持したいコンテンツはお客様ご自身でバックアップする責任があります。',
      s8Title: '8. 規約の変更',
      s8Content: '当社はいつでも本規約を更新または変更する権利を留保します。更新された規約はこのページで公開され、「最終更新日」が更新されます。サービスの継続的な使用は、更新された規約の受諾を構成します。最新の条項を確認するために、このページを定期的に確認することをお勧めします。',
      s9Title: '9. その他の規定',
      s9Item1: '分離可能性：本規約のいずれかの条項が無効または執行不能と判断された場合、その条項は必要な最小限の範囲で制限または除外され、他の条項の有効性に影響を与えません。',
      s9Item2: '完全合意：本規約およびプライバシーポリシーは、本サービスに関するお客様と当社間の完全な合意を構成し、以前の口頭または書面による合意に優先します。',
    },
    about: {
      title: 'Kokeへようこそ',
      intro: 'シンプルな信念から始まりました：言語は素晴らしい漫画の世界を探索する障壁となるべきではない。',
      missionTitle: '私たちの使命',
      missionContent: 'Kokeは、すべての漫画愛好者が障壁なく読書を楽しめる、真に効率的でシンプル、無料のインテリジェント翻訳ツールの構築に尽力しています。テクノロジーは人に仕えるものであり、最もシームレスな方法で障壁を取り除き、素晴らしい物語とアートを心に届けるべきだと信じています。',
      coreTitle: '私たちのコア：プライバシーと利便性',
      toolTitle: '純粋なツール',
      toolContent: 'Kokeは機能に特化したツールです。アップロードして翻訳する、それだけです。コミュニティを構築せず、コンテンツを保存せず、ユーザーを追跡しません。',
      privacyTitle: 'プライバシー第一',
      privacyContent: 'お客様のデータはお客様のためにのみ働きます。プライバシー保護を最大化するため、翻訳に必要な画像処理と認識はブラウザローカルで完了します。オリジナル画像をサーバーに送信することはありません。すべての関連データは24時間後に自動的かつ完全にクリアされます。コピーは保持しません。これはお客様の信頼への約束です。',
      efficientTitle: 'シンプルで効率的',
      efficientContent: '不要な機能と複雑なインターフェースを排除し、アップロードから翻訳結果までの全体的な速度と体験の向上に集中し、翻訳をページをめくるように自然で流暢なものにします。',
      futureTitle: '未来への展望',
      futureContent: '翻訳の正確性と複雑なレイアウトの処理能力を継続的に最適化し、「効率的、シンプル、無料、安全」の初心を厳格に遵守します。Kokeが漫画宇宙を探索する際の、手軽で信頼できる鍵となることを願っています。',
      thankYou: 'ご利用ありがとうございます。',
      signature: 'Kokeチーム',
    },
  },
  seoPage:   {
    "faq": {
      "h1": "よくある質問",
      "lead": "無料枠、翻訳速度、クレジット、プライバシー、使い方に関する詳しい回答です。",
      "ctaTitle": "まだ質問がありますか？ツールを試す",
      "ctaDesc": "漫画画像をアップロードして、AI翻訳とオリジナルレンダリングを無料体験できます。",
      "items": [
        {
          "q": "無料の公共キューは毎日何ページ翻訳できますか？",
          "a": "ログインなしで毎日20回まで無料翻訳できます。品質はVIPキューと同じです。"
        },
        {
          "q": "なぜ翻訳に時間がかかるのですか？",
          "a": "品質のため大モデル翻訳を使用しており、1枚あたり平均7〜8秒です。公共キューは待ち時間が発生する場合があります。"
        },
        {
          "q": "なぜ画像によってクレジット消費が違うのですか？",
          "a": "通常画像は1クレジット。長すぎる画像や超高解像度画像は追加消費します。2クレジットは概ね4K超に相当します。"
        },
        {
          "q": "翻訳に問題があった場合は？",
          "a": "翻訳問題は全面的にサポートします。失敗した翻訳はクレジットを返還します。"
        },
        {
          "q": "機械翻訳と大モデル翻訳の違いは？",
          "a": "従来の機械翻訳は固定ルールに依存し硬くなりがちです。大モデル翻訳は文脈、セリフ、擬音、文化的表現をより自然に扱います。"
        },
        {
          "q": "アップロードした画像は保存されますか？",
          "a": "長期保存はしません。翻訳結果の生成にのみ使用し、完了後24時間以内に自動削除。学習にも使いません。"
        },
        {
          "q": "対応フォーマットは？",
          "a": "JPG、PNG、WEBPなど一般的な形式に対応しています。"
        },
        {
          "q": "対応言語は？",
          "a": "現在は中国語、繁体字中国語、英語などに対応。追加言語を順次提供予定です。"
        }
      ]
    },
    "guide": {
      "h1": "漫画翻訳完全ガイド",
      "lead": "日本漫画の中国語化、英語化、章単位のバッチ処理まで、準備から書き出しまでを網羅します。",
      "ctaTitle": "準備ができたら",
      "ctaDesc": "オンラインツールを開き、画像をまとめてアップロードしてAI漫画翻訳を体験してください。",
      "sections": [
        {
          "title": "1. 翻訳前の準備",
          "paragraphs": [
            "高品質な入力が高品質な出力につながります。鮮明なスクリーンショットやスキャンを推奨します。",
            "縦長や高解像度画像は大画像対応を確認してください。"
          ],
          "list": [
            "JPG / PNG / WEBP を使用",
            "文字領域を鮮明に",
            "読む順に画像を整理"
          ]
        },
        {
          "title": "2. バッチアップロード",
          "paragraphs": [
            "翻訳ページで複数画像を一括選択できます。進捗はファイル単位で確認できます。",
            "1ページずつより、章単位の一括処理が効率的です。"
          ],
          "list": [
            "複数画像を一括追加",
            "リアルタイム進捗表示",
            "完了後に一括ダウンロード"
          ]
        },
        {
          "title": "3. オリジナルレンダリングの価値",
          "paragraphs": [
            "文字を単に上書きすると不自然になりがちです。オリジナルレンダリングは背景と融合し、プロの翻訳に近い仕上がりになります。"
          ],
          "list": [
            "作画スタイルを維持",
            "吹き出しと背景に馴染む訳文",
            "配布・公開向けの仕上がり"
          ]
        },
        {
          "title": "4. 品質と速度のバランス",
          "paragraphs": [
            "急ぐときはVIP、無料利用なら公共キューでも同等品質です。大モデル翻訳は文脈理解に優れます。"
          ],
          "list": [
            "公共キュー：無料・待ちあり",
            "VIP：高速・大画像・詳細設定",
            "失敗時はクレジット返還あり"
          ]
        },
        {
          "title": "5. 書き出し後の注意",
          "paragraphs": [
            "完了後は早めにダウンロードしてください。用途に合わせて形式を選べます。",
            "固有名詞の校正には原稿と訳文の対応を残すのがおすすめです。"
          ],
          "list": [
            "JPG / PNG / WEBP 対応",
            "原稿と訳文を保存",
            "著作権と公開ルールに注意"
          ]
        }
      ]
    }
  },
}
